/* eslint-disable react-hooks/exhaustive-deps */
"use client"

import { useState, useRef, useEffect } from "react"
import { Box, Container } from "@mui/material"
import { FiltersSection } from "../../components/filters-section"
import { ProvidersBlock } from "./providers-block"
import { ProviderDetailsBlock } from "./provider-details-block"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch, RootState } from "../../store"
import { refreshToken } from "../../store/slices/auth"
import { requestSignalCompaniesData, requestSignalDimensionData, requestSignalOriginData, requestSignalPeriodsData, requestSignalProjectsData, requestSignalProviderDetailsData, requestSignalProvidersData, requestSignalStatusData } from "../../services/signalApi"
import { dimensionsReset, originsReset, periodsReset, projectsReset, providerDetailsReset, providersReset, statusReset } from "../../store/slices/provider"


export default function ProvidersView() {

    const dispatch = useDispatch<AppDispatch>();
    const authState = useSelector((state: RootState) => state.auth);
    const providerState = useSelector((state: RootState) => state.provider);

    const [selectedProvider, setSelectedProvider] = useState<any>(null)
    const [filterValues, setFilterValues] = useState<Record<string, string>>({
        coin: 'PEN',
        company: 'all',
        mode: 'Proyecto',
        project: 'all',
        period: 'all',
        status: 'all',
        origin: 'all',
        quantity: '100',
        searchText: '',
    })
    const [filterPreviousValues, setFilterPreviousValues] = useState<Record<string, string>>(filterValues)
    
    const [currentViewProviders, setCurrentViewProviders] = useState<'Tabla' | 'Gráfico'>('Tabla');
    const [currentViewDetails, setCurrentViewDetails] = useState<'Tabla' | 'Gráfico'>('Tabla');
    const detailsBlockRef = useRef<HTMLDivElement>(null)
    
    useEffect(() => {
        if (authState.token && authState.moduleId && authState.userId && !authState.connectionId) {
            dispatch(refreshToken(authState.token));
        }
        // eslint-disable-next-line
    }, [authState.token, authState.moduleId, authState.userId]);

    useEffect(() => {
        if (!providerState.providers.length || selectedProvider || providerState.providersRequesLoading) {
            return;
        }
        handleProviderSelect({...providerState.providers[0], id: providerState.providers[0].CodProveedor})
        // eslint-disable-next-line
    }, [providerState.providers]);
    
    useEffect(() => {
        if (!authState.connectionId) {
            return;
        }
        if (!providerState.companies.length) requestSignalCompaniesData();
        getProjectsData(filterValues, filterPreviousValues)
        getPeriodsData(filterValues, filterPreviousValues);
        getStatusData(filterValues, filterPreviousValues);
        getOriginData(filterValues, filterPreviousValues);
        getProvidersData(filterValues, filterPreviousValues);
        setFilterPreviousValues(filterValues);
        // eslint-disable-next-line
    }, [authState.connectionId, filterValues]);
    
    useEffect(() => {
        if (!selectedProvider?.id) {
            return;
        }
        console.log('filterValues', filterValues)
        getProviderDetailsData(filterValues, filterPreviousValues);
    }, [selectedProvider?.id]);

    const getProjectsData = (
        filterValues: Record<string, string>, 
        filterPreviousValues: Record<string, string>
    ) => {
        if (
            filterValues.company === filterPreviousValues.company
            && filterValues.mode === filterPreviousValues.mode
            && providerState.projects.length !== 0
        ) {
            return;            
        }
        if (filterValues.mode === 'Proyecto') {
            dispatch(projectsReset());
            requestSignalProjectsData(filterValues.company);
            
        } else {
            dispatch(dimensionsReset());
            requestSignalDimensionData(filterValues.company, filterValues.mode);
        }
    }

    const getPeriodsData = (
        filterValues: Record<string, string>, 
        filterPreviousValues: Record<string, string>
    ) => {
        if (
            filterValues.company === filterPreviousValues.company
            // && filterValues.mode === filterPreviousValues.mode
            && filterValues.project === filterPreviousValues.project
            && providerState.periods.length !== 0
        ) {
            return;            
        }
        dispatch(periodsReset());
        requestSignalPeriodsData(filterValues.company, filterValues.project);
    }

    const getStatusData = (
        filterValues: Record<string, string>, 
        filterPreviousValues: Record<string, string>
    ) => {
        if (
            filterValues.company === filterPreviousValues.company
            // && filterValues.mode === filterPreviousValues.mode
            && filterValues.project === filterPreviousValues.project
            && filterValues.period === filterPreviousValues.period
            && providerState.status.length !== 0
        ) {
            return;            
        }
        dispatch(statusReset());
        requestSignalStatusData(
            filterValues.company, 
            filterValues.project, 
            filterValues.period
        );
    }

    const getOriginData = (
        filterValues: Record<string, string>, 
        filterPreviousValues: Record<string, string>
    ) => {
        if (
            filterValues.company === filterPreviousValues.company
            // && filterValues.mode === filterPreviousValues.mode
            && filterValues.project === filterPreviousValues.project
            && filterValues.period === filterPreviousValues.period
            && filterValues.status === filterPreviousValues.status
            && providerState.origins.length !== 0
        ) {
            return;            
        }
        dispatch(originsReset());
        requestSignalOriginData(
            filterValues.company, 
            filterValues.project, 
            filterValues.period, 
            filterValues.status
        );
    }

    const getProvidersData = (
        filterValues: Record<string, string>, 
        filterPreviousValues: Record<string, string>
    ) => {
        if (
            filterValues.company === filterPreviousValues.company
            && filterValues.mode === filterPreviousValues.mode
            && filterValues.project === filterPreviousValues.project
            && filterValues.period === filterPreviousValues.period
            && filterValues.status === filterPreviousValues.status
            && filterValues.origin === filterPreviousValues.origin
            && filterValues.quantity === filterPreviousValues.quantity
            && filterValues.searchText === filterPreviousValues.searchText
            && providerState.providers.length !== 0
        ) {
            return;            
        }
        setSelectedProvider(null)
        dispatch(providersReset());
        requestSignalProvidersData(
            filterValues.company, 
            filterValues.project, 
            filterValues.period, 
            filterValues.status, 
            filterValues.origin,
            filterValues.mode,
            filterValues.quantity,
            filterValues.searchText,
        );
    }

    const getProviderDetailsData = (
        filterValues: Record<string, string>, 
        filterPreviousValues: Record<string, string>
    ) => {
        dispatch(providerDetailsReset());
        if (!selectedProvider) {
            return;
        }
        requestSignalProviderDetailsData(
            filterValues.company, 
            filterValues.project, 
            filterValues.period, 
            filterValues.status, 
            filterValues.origin,
            selectedProvider.id,
            filterValues.mode,
            filterValues.quantity,
        );
    }

    const handleFilterChange = (filterId: string, value: string) => {
        setFilterValues((prev) => ({
            ...prev,
            [filterId]: value,
        }))
    }

    const handleProviderSelect = (provider: any) => {
        console.log(provider)
        setSelectedProvider(provider)
        setTimeout(() => {
            detailsBlockRef.current?.scrollIntoView({ behavior: "smooth", block: "start" })
        }, 100)
    }

    return (
        <Container
            maxWidth="xl"
            sx={{
                py: 4,
                display: "flex",
                flexDirection: "column",
                minHeight: "100%",
            }}
        >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <FiltersSection 
                filters={[
                    {
                        label: "Moneda",
                        value: "coin",
                        options: [
                            { label: "Soles", value: "PEN" },
                            { label: "Dolares", value: "USD" },
                        ],
                    },
                    {
                        label: "Empresa",
                        value: "company",
                        options: [
                            { label: "Todos", value: "all" },
                            ...providerState.companies.map(c => ({
                                label: c.Descripcion,
                                value: c.CodEmpresa,
                            })),
                        ],
                    },
                    {
                        label: "Modo",
                        value: "mode",
                        options: [
                            { label: "Proyecto", value: "Proyecto" },
                            { label: "Dimensión 1", value: "Dimension 1" },
                            { label: "Dimensión 2", value: "Dimension 2" },
                            { label: "Dimensión 3", value: "Dimension 3" },
                            { label: "Dimensión 4", value: "Dimension 4" },
                            { label: "Dimensión 5", value: "Dimension 5" },
                        ],
                    },
                    {
                        label:  filterValues.mode,
                        value: "project",
                        type: 'search',
                        options: [
                            { label: "Todos", value: "all" },
                            ...(filterValues.mode === 'Proyecto' 
                                ? providerState.projects.map(c => ({
                                    label: c.Descripcion,
                                    value: c.CodProyecto,
                                }))
                                : providerState.dimensions.map(c => ({
                                    label: c.Descripcion,
                                    value: c.CodProyectoVector,
                                }))
                            ),
                        ],
                    },
                    {
                        label: "Periodo",
                        value: "period",
                        options: [
                            { label: "Todos", value: "all" },
                            ...providerState.periods.map(c => ({
                                label: c.Descripcion,
                                value: c.AnoMes,
                            })),
                        ],
                    },
                    {
                        label: "Estado",
                        value: "status",
                        options: [
                            { label: "Todos", value: "all" },
                            ...providerState.status.map(c => ({
                                label: c.Estado,
                                value: c.Estado,
                            })),
                        ],
                    },
                    {
                        label: "Origen",
                        value: "origin",
                        options: [
                            { label: "Todos", value: "all" },
                            ...providerState.origins.map(c => ({
                                label: c.Origen ?? 'null',
                                value: c.Origen,
                            })),
                        ],
                    },
                    {
                        label: "Primeros",
                        value: "quantity",
                        options: [
                            { label: "200", value: "200" },
                            { label: "100", value: "100" },
                            { label: "50", value: "50" },
                            { label: "10", value: "10" },
                        ],
                    },
                    {
                      label: "Búscar proveedor",
                      value: "searchText",
                      type: "text",
                      debounce: 500,
                      options: [],
                    },
                ]} 
                onFilterChange={handleFilterChange} 
                values={filterValues} 
            />

            {providerState.providersRequesLoading === false 
                ? <>
                    <ProvidersBlock
                        selectedCoin={filterValues.coin as any}
                        providers={providerState.providers}
                        onProviderSelect={handleProviderSelect}
                        selectedProviderId={selectedProvider?.id}
                        currentView={currentViewProviders}
                        setCurrentView={setCurrentViewProviders}
                    />
                    {selectedProvider && (
                        <Box ref={detailsBlockRef}>
                            {providerState.providerDetailssRequesLoading === false 
                                ? <ProviderDetailsBlock 
                                    selectedCoin={filterValues.coin as any}
                                    providerName={selectedProvider.Descripcion} 
                                    invoices={providerState.providerDetails}
                                    currentView={currentViewDetails}
                                    setCurrentView={setCurrentViewDetails}
                                />
                                : <>cargando...</>
                            }
                        </Box>
                    )}
                </>
                : <>cargando...</>
            }
        </Box>
        </Container>
    )
}
